import { useSelector } from 'react-redux';
import store from 'store';
import { selectActiveAccountId } from 'store/session/index';

export function useIsGuest() {
  return useSelector(selectActiveAccountId) == undefined;
}

export function isGuest() {
  return store.getState().session.accountId == undefined;
}

export type UseIsGuest = typeof useIsGuest;
